import { PACKAGE_SEARCH_DATA, persistSearchData } from '@/shared-utils/local-forage-helper'
import packagesSearch from '@/shared-utils/packages-search'
import firePackagesFormGA4Event, { fireOnSearchButtonClickForSuccessfulSearchTrigger } from '../ga4'
import type { PackagesFormStateType } from '../types'
import { FLY_DRIVE, STAY_DRIVE, STAY_FLY, STAY_FLY_DRIVE } from './TripTypes'

export const initialState: PackagesFormStateType = {
  tripType: STAY_FLY,
  partialStay: false,
  startLocation: null,
  endLocation: null,
  startDate: '',
  endDate: '',
  hotelStartDate: '',
  hotelEndDate: '',
  travelers: {
    rooms: 1,
    adults: 2,
    children: 0,
    childrenAges: {},
    lapInfants: 0,
  },
  isRecommendedTrip: false,
  includeBasicEconomy: true,
  pickupCarSomewhere: false,
  rcLocation: null,
  rcPickupDate: '',
  rcDropoffDate: '',
  rcPickupTime: '10:00',
  rcDropoffTime: '10:00',
}

export const onSubmit = (pageName: 'homepage' | 'landing', values: PackagesFormStateType) => {
  const { startLocation, endLocation, travelers, ...rest } = values
  const isPartialStayDateValid =
    !!rest.partialStay && (rest.hotelStartDate !== rest.startDate || rest.hotelEndDate !== rest.endDate)

  if (startLocation?.type === 'AIRPORT' && startLocation?.lat === 0 && startLocation?.lon === 0) {
    startLocation.type = 'GDS_CITY'
  }
  if (endLocation?.type === 'AIRPORT' && endLocation?.lat === 0 && endLocation?.lon === 0) {
    endLocation.type = 'GDS_CITY'
  }

  packagesSearch({
    startLocationObject: startLocation,
    endLocationObject: endLocation,
    childrenAges: travelers?.childrenAges,
    roomCount: travelers?.rooms,
    adultCount: travelers?.adults,
    childrenCount: travelers?.children,
    ...rest,
    isPartialStayDateValid: isPartialStayDateValid && rest.tripType !== STAY_DRIVE,
  })

  void persistSearchData({ key: PACKAGE_SEARCH_DATA, recentSearchData: values })
  firePackagesFormGA4Event(initialState, values, pageName)
  fireOnSearchButtonClickForSuccessfulSearchTrigger(pageName, values.tripType)
}

export const getTextString = (tripType: string) => (text: string) => {
  switch (tripType) {
    case STAY_FLY_DRIVE:
      return `${text}hotel, flight and car`
    case FLY_DRIVE:
      return `${text}flight and car`
    case STAY_DRIVE:
      return `${text}hotel and car`
    case STAY_FLY:
    default:
      return `${text}hotel and flight`
  }
}

export const CALENDAR_POPOVER_SELECTOR = '[aria-label="Calendar navigation tooltip"]'

export const fields = [
  'startLocation',
  'endLocation',
  'startDate',
  'endDate',
  'hotelStartDate',
  'hotelEndDate',
  'travelers',
  'tripType',
  'includeBasicEconomy',
  'pickupCarSomewhere',
  'rcLocation',
  'rcPickupDate',
  'rcDropoffDate',
  'rcPickupTime',
  'rcDropoffTime',
  'isInfantOnInternationalTravel',
] as const
